const loading = () => <><div className="col-12 col-md-4"><div className="px-5 my-5"><div className="waveimg"></div></div>
<div className="heading3 text-center"><div className="wavecon"></div></div></div>
<div className="col-12 col-md-4"><div className="px-5 my-5"><div className="waveimg"></div></div>
<div className="heading3 text-center"><div className="wavecon"></div></div></div>
<div className="col-12 col-md-4"><div className="px-5 my-5"><div className="waveimg"></div></div>
<div className="heading3 text-center"><div className="wavecon"></div></div></div></>
export default loading;